export default "__VITE_ASSET__CzbEfNet__"